import { render } from "./FormWartungsprotokoll_RMG_CCP_Connect.vue?vue&type=template&id=60d74d63&scoped=true"
import script from "./FormWartungsprotokoll_RMG_CCP_Connect.vue?vue&type=script&lang=js"
export * from "./FormWartungsprotokoll_RMG_CCP_Connect.vue?vue&type=script&lang=js"

import "./FormWartungsprotokoll_RMG_CCP_Connect.vue?vue&type=style&index=0&id=60d74d63&lang=scss&scoped=true"

import exportComponent from "/home/hiro/lab/hands4you-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d74d63"]])

export default __exports__